import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const container = "omponents__ErrorUI__ConnectionError__ConnectionError_styles_ts-container-c1uul1h5";
export const pageTitle = "omponents__ErrorUI__ConnectionError__ConnectionError_styles_ts-pageTitle-pct6e7d";
export const description = "omponents__ErrorUI__ConnectionError__ConnectionError_styles_ts-description-d1yv7sa9";
export const btn = "omponents__ErrorUI__ConnectionError__ConnectionError_styles_ts-btn-b1qk6nd1";
export const img = "omponents__ErrorUI__ConnectionError__ConnectionError_styles_ts-img-i1ryg9f0";

require("./ConnectionError.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ConnectionError.styles.ts");